exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".new-user-dicount-section[data-v-4c53721a]{margin-top:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-4c53721a&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/CheckoutStepOrderSummary.vue
// module id = 57
// module chunks = 0